module.exports = __webpack_public_path__ + "img/cloundwise3.8025530c.png";